import React, { PropsWithChildren } from 'react';

import Footer from './footer';
import Header from './header';
import { S } from './style';

export interface LayoutProps extends PropsWithChildren {
  noHeader?: boolean;
  noFooter?: boolean;
  noFullWidth?: boolean;
}

function Layout({ children, noHeader, noFooter, noFullWidth }: LayoutProps) {
  return (
    <div>
      {!noHeader && <Header />}
      <S.BodyContainer noFullWidth={noFullWidth} noHeader={noHeader}>
        {children}
      </S.BodyContainer>
      {!noFooter && <Footer />}
    </div>
  );
}

export default Layout;
